import React from 'react';

export const PERSONAL_EFFORT_QUESTION = 'How hard did this activity feel for you overall?';

export const PERSONAL_EFFORT_HELP =
    'Rate your overall physical effort during the whole activity, not only the hardest moment. ' +
    'Do not base the rating only on pain, technical difficulty, mood, or whether you performed well.';

const ANCHORS = {
    1: 'Very easy',
    5: 'Moderately hard',
    10: 'Maximum effort',
};

const VALUES = Array.from({ length: 10 }, (_, i) => i + 1);

/**
 * Personal Effort (1-10) selector.
 *
 * Renders ten explicit buttons with no default so the user must make a
 * deliberate choice; a missing rating is never silently treated as 5 or 0.
 *
 * @param {Object} props
 * @param {number|null} props.value
 * @param {(value: number) => void} props.onChange
 */
const EffortScale = ({ value, onChange }) => {
    const selected = Number.isInteger(value) ? value : null;

    return (
        <div className="la-field" role="radiogroup" aria-label={PERSONAL_EFFORT_QUESTION}>
            <label className="la-label">{PERSONAL_EFFORT_QUESTION}</label>
            <p className="la-help-text">{PERSONAL_EFFORT_HELP}</p>
            <div className="la-effort-scale">
                {VALUES.map((v) => (
                    <button
                        key={v}
                        type="button"
                        role="radio"
                        aria-checked={selected === v}
                        aria-label={ANCHORS[v] ? `${v} — ${ANCHORS[v]}` : String(v)}
                        className={`la-effort-btn${selected === v ? ' active' : ''}`}
                        onClick={() => onChange(v)}
                    >
                        {v}
                    </button>
                ))}
            </div>
            <div className="la-effort-anchors">
                <span>1 · {ANCHORS[1]}</span>
                <span>5 · {ANCHORS[5]}</span>
                <span>10 · {ANCHORS[10]}</span>
            </div>
            <div className="la-effort-current" aria-live="polite">
                {selected !== null
                    ? `Personal Effort: ${selected} / 10${ANCHORS[selected] ? ` — ${ANCHORS[selected]}` : ''}`
                    : 'Select a rating from 1 to 10'}
            </div>
        </div>
    );
};

export default EffortScale;
